import styled from 'styled-components';
import { COLORS, SIZES } from '@fupa/fupa-uikit';
import React from 'react';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1dqdctj-0"
})(["display:flex;flex-direction:column;align-items:center;width:100%;&:not(:last-child){margin-right:", ";@media only screen and (max-width:600px){margin-right:", ";}}"], SIZES['4'], SIZES['2']);
const Bar = styled.div.withConfig({
  componentId: "sc-1dqdctj-1"
})(["height:", ";border-radius:", ";background-color:rgba(255,255,255,0.5);width:100%;"], SIZES['2'], SIZES['1']);
const Progress = styled.span.withConfig({
  componentId: "sc-1dqdctj-2"
})(["height:100%;display:inherit;background-color:", ";width:", "%;border-radius:", ";max-width:100%;"], COLORS.white, props => props.progress, SIZES['1']);
export const ProgressBar = _ref => {
  let {
    progress
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "ProgressBar",
    "data-sentry-source-file": "ProgressBar.tsx"
  }, /*#__PURE__*/React.createElement(Bar, {
    "data-sentry-element": "Bar",
    "data-sentry-source-file": "ProgressBar.tsx"
  }, /*#__PURE__*/React.createElement(Progress, {
    progress: progress,
    "data-sentry-element": "Progress",
    "data-sentry-source-file": "ProgressBar.tsx"
  })));
};